<template>
  <div class="news-page">
    <div class="title">
      <img src="./home_mod_toutiao.png" alt="" />
      <div>推荐资讯</div>
    </div>
    <div class="content">
      <div class="content-left">
        <!-- swiper -->
        <div class="swiper-images">
          <div id="gallery-top" class="swiper-container">
            <div class="swiper-wrapper">
              <router-link
                :to="`/news_detail/${item.id}`"
                target="_blank"
                v-for="(item, index) in swipers"
                :key="index"
                class="swiper-slide"
              >
                <img :src="item.img" />
                <div class="swiper-text">
                  {{ item.title }}
                </div>
              </router-link>
            </div>
          </div>
          <div class="custom-btn">
            <div id="gallery-thumbs" class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  v-for="(item, index) in swipers"
                  :key="index"
                  class="swiper-slide swiper-slide-box"
                >
                  <img :src="item.img" />
                </div>
              </div>
            </div>
            <div class="swiper-button-next" slot="“pagination”" />
            <div class="swiper-button-prev" slot="“pagination”" />
          </div>
        </div>

        <!-- swiper -->

        <div class="news-list">
          <div class="nav-menu">
            <div
              class="nav-item"
              @click="toggleNav(item.id)"
              :class="activeClass == item.id ? 'active' : ''"
              v-for="item in navItems"
              :key="item.id"
            >
              <div
                :class="activeClass == item.id ? 'active-text' : ''"
                class="nav-item-text"
              >
                {{ item.categoryName }}
              </div>
            </div>
          </div>
          <router-link
            :to="`/news_detail/${item.id}`"
            target="_blank"
            class="list"
            v-for="(item, index) in newsList"
            :key="index"
          >
            <div class="left">
              <img :src="item.img" alt="" />
            </div>
            <div class="right">
              <div class="up right-common">
                <div class="up-left">
                  <!-- <img :src="avatar" alt="" /> -->
                  <!-- <div>{{ author }}</div> -->
                </div>
                <div class="up-right">{{ item.publish_time }}</div>
              </div>
              <div class="mid right-common">{{ item.title }}</div>
              <div class="down right-common">{{ item.profile }}</div>
            </div>
          </router-link>
          <div @click="loadMore" class="load-more">{{ loadMoreText }}</div>
        </div>
      </div>
      <AnchorRecommend :isLogin="isLogin" :toTopHeight="0" />
    </div>
  </div>
</template>

<script>
import { post, parseCookie } from "@/util/http";
// import NewsSwiper from "@/components/news-swiper/news-swiper";
import AnchorRecommend from "@/components/anchor-recommend/anchor-recommend";
import Swiper, { Navigation, Thumbs } from "swiper";
import "swiper/swiper-bundle.css";

Swiper.use([Navigation, Thumbs]);

export default {
  // metaInfo() {
  //   return {
  //     title: "Xôi Lạc TV - Trực Tiếp Bóng Đá Hôm Nay | Xem Bóng Đá Miễn Phí",
  //     meta: [
  //       {
  //         name: "keywords",
  //         content:
  //           "xoilac, xoilac tv, xôi lạc trực tiếp bóng đá hôm nay, truc tiep bong da, xem bong da truc tuyen",
  //       },
  //     ],
  //   };
  // },
  components: {
    // NewsSwiper,
    AnchorRecommend,
  },

  data() {
    return {
      uid: this.$store.state.userInfo.id ? this.$store.state.userInfo.id : 0,
      swipers: [],
      activeClass: 1,
      navItems: [],
      navFixed: "",
      newsList: "",
      avatar: require("./live_biaoqing.png"),
      author: "",
      categoryId: 1,
      page: 1,
      size: 20,
      isLogin: false,
      origin: window.location.origin,
      loadMoreText: "加载更多",
    };
  },
  computed: {},
  watch: {
    swipers() {
      this.$nextTick(() => {
        var galleryThumbs = new Swiper("#gallery-thumbs", {
          spaceBetween: 10,
          slidesPerView: 7,
          // loop: true,
          // loopedSlides: 9,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
        new Swiper("#gallery-top", {
          autoplay: {
            disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay.默认为true：停止。
            delay: 3000,
          },
          loop: true,
          // slidesPerView: "auto",
          // loopedSlides: 9,
          spaceBetween: 10,
          thumbs: {
            swiper: galleryThumbs,
          },
        });
      });
    },
  },
  async created() {
    // const cookie = document.cookie || "";
    // let { uid } = parseCookie(cookie);
    // this.uid = uid;
    // console.log("cookie", uid);
    if (this.uid) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
  },

  async mounted() {
    this.newsList = await this.getNewsList(
      this.categoryId,
      this.page,
      this.size
    );
    this.getNewsCategoryList();
    this.getNewsBannerList();
  },
  destroyed() {},
  methods: {
    async getNewsCategoryList() {
      const {
        data: { data },
      } = await post({ url: "/api/news/getNewsCategoryList" });
      this.navItems = data;
    },
    async getNewsBannerList() {
      const {
        data: { data },
      } = await post({
        url: "/api/news/getNewsBannerList",
      });
      this.swipers = data;
    },
    async toggleNav(index) {
      this.loadMoreText = "加载更多";
      this.activeClass = index;
      this.categoryId = index;
      this.page = 1;
      this.newsList = await this.getNewsList(index, 1, this.size);
    },
    async getNewsList(id, page, size) {
      const {
        data: { data },
      } = await post({
        url: "/api/news/getNewsList",
        data: {
          news_category_id: id,
          page: page,
          size: size,
        },
      });
      return data;
    },
    async loadMore() {
      let nextPage = await this.getNewsList(
        this.categoryId,
        ++this.page,
        this.size
      );
      if (nextPage) {
        this.newsList = [...this.newsList, ...nextPage];
      } else {
        this.loadMoreText = "没有了";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.swiper-images {
  position: relative;
  width: 10.13rem;
  height: 4.58rem;
  background-color: #fff;
  border-radius: 0.08rem;
  margin-left: 0;
  overflow-x: hidden;
  box-shadow: 0rem 0.03rem 0.12rem 0rem rgba(0, 0, 0, 0.1);
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.swiper-slide {
  background-size: cover;
  background-position: center;
}

#gallery-top {
  height: 80%; //占外框高度80%
  width: 100%;
  position: relative;
  .swiper-text {
    background-image: linear-gradient(0deg, #000, transparent);
    padding: 0 0.3rem;
    color: #fff;
    height: 0.62rem;
    line-height: 0.62rem;
    font-size: 0.22rem;
    width: 10.13rem;
    z-index: 999;
    position: absolute;
    bottom: 0;
    overflow: hidden;
  }
}
.custom-btn {
  position: relative;
}
#gallery-thumbs {
  height: 20%; //占外框高度20%
  box-sizing: border-box;
  padding: 0.1rem 0;
  margin: 0 0.56rem;
  img {
    border-radius: 0.08rem;
    width: 1.1rem;
    height: 0.72rem;
  }
}
// #gallery-thumbs
#gallery-thumbs .swiper-slide {
  // width: 1.16rem !important;
  border-radius: 0.1rem;
  // opacity: 0.4;
  // margin: 0 .03rem;
}
#gallery-thumbs .swiper-slide-thumb-active {
  //   box-shadow: 0rem 0rem .05rem #29f500;
  // width: 1.1rem;
  border: 0.03rem solid #26d99d;
}
/*去掉默认样式*/
.swiper-button-prev:after {
  display: none;
}
.swiper-button-next:after {
  display: none;
}

.swiper-button-prev {
  background: no-repeat center/100% url("./share_arr_left.png");
  left: 0.16rem;
}
.swiper-button-next {
  background: no-repeat center/100% url("./share_arr_right.png");
  right: 0.16rem;
}

.news-page {
  width: 14rem;
  margin: 0 auto;
  margin-bottom: 0.4rem;
  padding-top: 0.8rem;

  .nav-menu {
    display: flex;
    position: sticky;
    top: 0;
    // overflow-x: auto;
    // overflow-y: hidden;
    height: 0.56rem;
    background-color: #fff;
    // border: .01rem solid #26d99d;
    border-radius: 0.08rem;
    // padding-left: .35rem;
    border-bottom: 0.01rem solid rgba(0, 0, 0, 0.04);
    z-index: 5;

    .nav-item {
      display: flex;
      flex: 1;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      // margin-right: .46rem;

      z-index: 2;
      cursor: pointer;
      .nav-item-text {
        font-size: 0.18rem;
        color: #666;
        line-height: 0.18rem;
        text-align: center;
        font-weight: 500;
      }

      .active-text {
        color: #02a8a2;
      }
    }
    .active {
      border-bottom: 0.03rem solid #02a8a2;
    }
  }
}
.title {
  display: flex;
  width: 1.5rem;
  height: 0.5rem;
  margin-top: -0.12rem;
  align-items: center;
  font-size: 0.24rem;
  color: #333;
  font-weight: 500;
  img {
    width: 0.32rem;
    height: 0.32rem;
    margin-right: 0.08rem;
  }
}
.content {
  display: flex;
  .content-left {
    display: flex;
    flex-direction: column;
    margin-right: 0.12rem;
  }
  .news-list {
    width: 10.13rem;
    background-color: #fff;
    border-radius: 0.08rem;
    margin-top: 0.16rem;
    box-shadow: 0rem 0.03rem 0.12rem 0rem rgba(0, 0, 0, 0.1);
    .list {
      display: flex;
      margin: 0 0.24rem;
      padding: 0.24rem 0;
      border-bottom: 0.01rem solid #f0f0f0;
      .left {
        width: 2.58rem;
        height: 1.2rem;
        border-radius: 0.08rem;
        overflow: hidden;
      }
      img {
        width: 2rem;
        height: 1.2rem;
        border-radius: 0.08rem;
        object-fit: cover;
        transition: all 0.6s;
      }
      .left img:hover {
        transform: scale(1.4);
      }
      .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 0.16rem;
        width: 100%;
        .right-common {
          display: flex;
          height: 0.36rem;
        }
        .up {
          // display: flex;
          // justify-content: space-between;
          font-size: 0.16rem;
          color: #999;
          align-items: center;
          .up-left {
            color: #666;
            display: flex;
            align-items: center;
          }
          .up-left img {
            width: 0.24rem;
            height: 0.24rem;
            border-radius: 0.24rem;
            margin-right: 0.12rem;
          }
        }
        .mid {
          // margin-top: 0.3rem;
          width: 7.4rem;
          display: inline;
          font-size: 0.18rem;
          color: #333;
          font-weight: bold;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .down {
          width: 7.4rem;
          display: inline;
          font-size: 0.14rem;
          color: #999;
          font-weight: 400;
          line-height: 1.2;
          overflow: hidden;
          display: -webkit-box; //作为弹性伸缩盒子模型显示。
          -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
          -webkit-line-clamp: 2; //显示的行
        }
      }
    }
    .load-more {
      height: 0.48rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 0.01rem solid #f0f0f0;
      border-radius: 0.08rem;
      margin: 0.1rem 0.24rem;
      color: #999;
      font-size: 0.18rem;
    }
    .load-more:hover {
      border-color: #26d99d;
      color: #26d99d;
      cursor: pointer;
    }
  }
}
</style>
